import { create } from "zustand";
import type { CanvasTimePage } from "@/components/canvas/canvas-time-pages";

export interface CanvasTimePageMembership {
  spaceId: string | null;
  pages: CanvasTimePage[];
  nodeInputs: Map<string, string>;
}

interface CanvasTimePageState {
  layout: CanvasTimePageMembership | null;
  setLayout: (layout: CanvasTimePageMembership | null) => void;
  activePageIndex: number;
  resizingFrameIds: Set<string>;
  setActivePageIndex: (index: number) => void;
  beginFrameResize: (frameId: string) => void;
  endFrameResize: (frameId: string) => void;
  reset: () => void;
}

export const useCanvasTimePageStore = create<CanvasTimePageState>((set) => ({
  layout: null,
  setLayout: (layout) => set({ layout }),
  activePageIndex: 0,
  resizingFrameIds: new Set(),
  setActivePageIndex: (activePageIndex) =>
    set({ activePageIndex: Math.max(0, activePageIndex) }),
  beginFrameResize: (frameId) =>
    set((state) => {
      if (state.resizingFrameIds.has(frameId)) return state;
      return {
        resizingFrameIds: new Set(state.resizingFrameIds).add(frameId),
      };
    }),
  endFrameResize: (frameId) =>
    set((state) => {
      if (!state.resizingFrameIds.has(frameId)) return state;
      const resizingFrameIds = new Set(state.resizingFrameIds);
      resizingFrameIds.delete(frameId);
      return { resizingFrameIds };
    }),
  reset: () =>
    set({ layout: null, activePageIndex: 0, resizingFrameIds: new Set() }),
}));
